import type { FC } from "react";

import { useHeaderContext } from "@ui/eva-components/MobileFirstHeader/context";

import { Separator } from "@jti/core-components";
import { Button } from "@jti/core-components/components/Button";

import styles from "./SubmenuTitle.module.scss";

export type SubmenuTitleProps = {
  title: string;
  variant?: "general" | "ploomClub";
  descriptionPrefix?: string;
  secondDescriptionPrefix?: string;
  link?: {
    text: string;
    href: string;
  };
  showUserTier?: boolean;
};

export const SubmenuTitle: FC<SubmenuTitleProps> = ({
  title,
  variant = "general",
  descriptionPrefix,
  secondDescriptionPrefix,
  showUserTier,
  link,
}) => {
  const { userTier, loyaltyPoints } = useHeaderContext();

  const shouldDisplayLoyaltyData = userTier && loyaltyPoints;

  return (
    <div className={styles.submenuTitle}>
      <div className={styles.wrapper} data-testid="title">
        <p className={styles.title}>{title}</p>
        {shouldDisplayLoyaltyData && variant !== "general" && (
          <>
            <div className={styles.textWrapper}>
              {showUserTier && (
                <p className={styles.descriptionStyle}>
                  {descriptionPrefix} <strong className={styles.tier}>{userTier}</strong>
                </p>
              )}

              {showUserTier && secondDescriptionPrefix && <div className={styles.divider}></div>}

              {secondDescriptionPrefix && (
                <p className={styles.descriptionStyle}>
                  {secondDescriptionPrefix} <strong className={styles.points}>{loyaltyPoints}</strong>
                </p>
              )}
            </div>
            {link && (
              <div className={styles.buttonWrapper}>
                <Button href={link.href} variant="text-muted" size="md">
                  {link.text}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
      <Separator />
    </div>
  );
};
